import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { globalStore } from '../GlobalStore';
import { messageModel } from './MessageModel';
import { ChatRoomListPanel } from './components/ChatRoomListPanel';
import { ChatDetailPanel } from './components/ChatDetailPanel';
import './MessageStyle.css';
import { LoginModalConfig } from '../components/LoginModal/LoginModalConfig';
import { MessageUnreadBadgeConfig } from './MessageUIConfig';

const MessagePage: React.FC = observer(() => {
  const navigate = useNavigate();
  const initialized = globalStore.initialized;
  const isLoggedIn = globalStore.isLoggedIn;
  const buyerId = globalStore.currentBuyer?.buyerId;

  useEffect(() => {
    if (!initialized) {
      return;
    }
    if (!isLoggedIn) {
      globalStore.loginModalVisible = true;
      navigate('/', { replace: true });
    }
  }, [initialized, isLoggedIn, navigate]);

  useEffect(() => {
    globalStore.selectedMenuKey = 'message';
    globalStore.forceWhiteHeader = true;
    window.scrollTo(0, 0);
    return () => {
      messageModel.reset();
      globalStore.forceWhiteHeader = false;
    };
  }, []);

  useEffect(() => {
    if (!initialized || !isLoggedIn || !buyerId) {
      return;
    }
    void messageModel.init();
  }, [initialized, isLoggedIn, buyerId]);

  return (
    <div
      className="message-page"
      style={
        {
          '--message-primary': LoginModalConfig.primaryColor,
          '--message-unread-badge-size': `${MessageUnreadBadgeConfig.diameter}px`,
          '--message-unread-badge-font-size': `${MessageUnreadBadgeConfig.fontSize}px`,
        } as React.CSSProperties
      }
    >
      <div className="message-page-inner">
        <aside className="message-sidebar">
          <div className="message-sidebar-title">消息</div>
          <ChatRoomListPanel />
        </aside>
        <main className="message-main">
          <ChatDetailPanel />
        </main>
      </div>
    </div>
  );
});

export default MessagePage;
